import { useAtomValue } from 'jotai';

import { ProviderNotHereDescription, ProviderNotHereDescriptionProps } from './ProviderNotHereDescription';
import { useChatDrawerButtonUtils } from './chat/useChatDrawerButtonUtils';
import { VisitorDrawerState, providerIsOnlineAtom, visitorDrawerStateAtom } from './state';

export function ProviderNotHereDescriptionWrapper(
  props: Omit<ProviderNotHereDescriptionProps, 'providerIsOnline' | 'onOpenChatDrawer'>,
) {
  const { toggleChatDrawer } = useChatDrawerButtonUtils();
  const drawerState = useAtomValue(visitorDrawerStateAtom);
  const providerIsOnline = useAtomValue(providerIsOnlineAtom);

  return (
    <ProviderNotHereDescription
      providerIsOnline={providerIsOnline}
      onOpenChatDrawer={() => {
        if (drawerState !== VisitorDrawerState.CHAT) {
          toggleChatDrawer();
        }
        props.onClose();
      }}
      {...props}
    />
  );
}
